<template>
  <Home />
</template>
   
<script>
//import Lista from "./Lista";
import Home from "../Home";
export default {
  name: "Atendimento-Index",
  props: {
    title: { type: String, default: "Title" },
  },
  components: {
    Home,
  },
  data: () => ({}),
  methods: {},
};
</script>